// extracted by extract-css-chunks-webpack-plugin
module.exports = {"usersList":"usersList__usersList___BuFlB","usersListBody":"usersList__usersListBody___31zzi"};
    if(module.hot) {
      // 1778083487357
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  